module.exports = __webpack_public_path__ + "img/busness_models.d1d86c9a.png";